module.exports = __webpack_public_path__ + "img/home inactive.688e3b3f.svg";